import React from "react";
import { Lock, ShieldCheck } from "lucide-react";
import CaixaLogo from "./CaixaLogo";

/**
 * Full-screen overlay shown during login (3s minimum).
 * - Animated rotating security ring
 * - Padlock icon in the center
 * - HolaBank logo below
 * - Bank-grade messaging
 */
const SecureLoginOverlay = ({ show }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-white/95 backdrop-blur-sm animate-fade-in">
      <div className="flex flex-col items-center text-center px-8">
        {/* Animated padlock + ring */}
        <div className="relative w-44 h-44 flex items-center justify-center">
          {/* Outer rotating ring */}
          <svg
            className="absolute inset-0 w-full h-full animate-spin-slow"
            viewBox="0 0 100 100"
            fill="none"
          >
            <circle
              cx="50"
              cy="50"
              r="46"
              stroke="#E2E8F0"
              strokeWidth="2"
            />
            <circle
              cx="50"
              cy="50"
              r="46"
              stroke="#007EAE"
              strokeWidth="3"
              strokeLinecap="round"
              strokeDasharray="60 260"
            />
          </svg>

          {/* Inner counter-rotating dotted ring */}
          <svg
            className="absolute inset-3 w-[88%] h-[88%] animate-spin-rev"
            viewBox="0 0 100 100"
            fill="none"
          >
            <circle
              cx="50"
              cy="50"
              r="42"
              stroke="#0098D4"
              strokeWidth="1.5"
              strokeDasharray="2 6"
              strokeLinecap="round"
              opacity="0.6"
            />
          </svg>

          {/* Center disc with padlock */}
          <div className="relative w-24 h-24 rounded-full bg-[#007EAE] shadow-lg flex items-center justify-center">
            <Lock className="w-11 h-11 text-white animate-lock-pulse" strokeWidth={2.2} />
          </div>
        </div>

        {/* Logo */}
        <div className="mt-8">
          <CaixaLogo size={42} />
        </div>

        {/* Messaging */}
        <h3 className="mt-5 text-[#003E7E] font-semibold text-xl" style={{ fontFamily: "Georgia, serif" }}>
          Connexion sécurisée en cours…
        </h3>
        <p className="mt-2 text-slate-600 text-sm max-w-md flex items-center gap-2 justify-center">
          <ShieldCheck className="w-4 h-4 text-[#007EAE]" />
          Vérification de vos identifiants par chiffrement bancaire.
        </p>

        {/* Loading bar */}
        <div className="mt-6 w-72 h-1 rounded-full bg-slate-200 overflow-hidden">
          <div className="h-full w-1/3 bg-[#007EAE] rounded-full animate-loading-bar" />
        </div>
      </div>
    </div>
  );
};

export default SecureLoginOverlay;
